import { useCurrentModule } from '../components';
export const REDESIGNED_DISCLAIMERS_SPEC = 'eclipseTrustBuildersRedesign';
export const useRedesignedDisclaimers = () => {
  const module = useCurrentModule();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  return experiments.isEnabled(REDESIGNED_DISCLAIMERS_SPEC);
};
//# sourceMappingURL=useRedesignedDisclaimers.js.map